import $ from 'jquery';
import { IdleSessionTimeout } from "idle-session-timeout";
import auth from '@/classes/auth';

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  IdleTimeout Module
//
///////////////////////////////////////////////////////////////////////////////////////////////////

const idletimeout = {
    session: null,

    async register() {
        $(() => {
            // `.off()` because this can be called multiple times, including with HMR. Also using `click.idle` instead of `click` to be able to target only these events.
            $(document)
                .off('click.idle', '#timeout-modal .btn-logout')
                .on('click.idle', '#timeout-modal .btn-logout', function() {
                    document.getElementById('logout-form').submit();
                });

            $(document)
                .off('click.idle', '#timeout-modal .btn-continue')
                .on('click.idle', '#timeout-modal .btn-continue', function() {
                    if (idletimeout.session) idletimeout.session.reset();
                });
        });
    },

    ///////////////////////////////////////////////////////////////////////////////////////////////////
    //
    //  Methods
    //
    ///////////////////////////////////////////////////////////////////////////////////////////////////
    init: function() {
        // Time out after 20 min of inactivity
        idletimeout.session = new IdleSessionTimeout(20 * 60 * 1000); // Auto reset on any user event
        //idletimeout.session = new IdleSessionTimeout(20 * 60 * 1000, "page load"); // Only reset on page load

        // Session has timed out because of inactivity
        idletimeout.session.onTimeOut = () => {
            auth.logout();
            window.location.href = '/';
        };

        idletimeout.session.onTimeLeftChange = (timeLeft) => {
            var seconds = Math.ceil(timeLeft / 1000);
            $("#timeout-modal").find('#seconds_remain').html(seconds);

            // We have less than 60 seconds left before we're timed out
            if ((timeLeft / 1000) < 60) {
                $("#timeout-modal").modal({backdrop: 'static', keyboard: false});
            } else {
                $("#timeout-modal").modal('hide');
            }
        };

        idletimeout.session.start();
    },
};

export default idletimeout;
